import { render, staticRenderFns } from "./MarketingCreditsModal.vue?vue&type=template&id=169524a7&scoped=true"
import script from "./MarketingCreditsModal.vue?vue&type=script&lang=js"
export * from "./MarketingCreditsModal.vue?vue&type=script&lang=js"
import style0 from "./MarketingCreditsModal.vue?vue&type=style&index=0&id=169524a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169524a7",
  null
  
)

export default component.exports